import React, { useState } from "react";
import { Alert, Button, Form, Modal, Spinner } from "react-bootstrap";
import api from "../../services/api";
import FluxopayReceivingAccountCard from "./FluxopayReceivingAccountCard";

export default function FluxopayReceivingAccountSection() {
  const [show, setShow] = useState(false);
  const [version, setVersion] = useState(0);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");
  const [form, setForm] = useState({ pix_key: "", password: "", confirm_ownership: false });

  const close = () => {
    if (saving) return;
    setShow(false);
    setError("");
    setForm({ pix_key: "", password: "", confirm_ownership: false });
  };

  const submit = async event => {
    event.preventDefault();
    setSaving(true);
    setError("");
    try {
      await api.put("/api/fluxopay/payout-destination", form);

      setSaving(false);
      setShow(false);
      setError("");
      setForm({
        pix_key: "",
        password: "",
        confirm_ownership: false,
      });

      setVersion(value => value + 1);
    } catch (requestError) {
      setError(requestError?.response?.data?.message || "Não foi possível alterar a chave Pix.");
    } finally { setSaving(false); }
  };

  return <>
    <FluxopayReceivingAccountCard key={version} onEdit={() => setShow(true)} />
    <Modal show={show} onHide={close} centered>
      <Form onSubmit={submit}>
        <Modal.Header closeButton><Modal.Title>Alterar chave Pix</Modal.Title></Modal.Header>
        <Modal.Body>
          <Alert variant="warning">Por segurança, uma alteração bloqueia novos repasses durante 24 horas. A chave deve ser o CNPJ da própria clínica.</Alert>
          {error && <Alert variant="danger">{error}</Alert>}
          <Form.Group className="mb-3"><Form.Label>Chave Pix CNPJ</Form.Label><Form.Control value={form.pix_key} onChange={event => setForm(current => ({ ...current, pix_key: event.target.value }))} required /></Form.Group>
          <Form.Group className="mb-3"><Form.Label>Senha atual</Form.Label><Form.Control type="password" autoComplete="current-password" value={form.password} onChange={event => setForm(current => ({ ...current, password: event.target.value }))} required /></Form.Group>
          <Form.Check type="checkbox" checked={form.confirm_ownership} onChange={event => setForm(current => ({ ...current, confirm_ownership: event.target.checked }))} label="Confirmo que esta chave pertence à clínica e autorizo seu uso nos repasses." required />
        </Modal.Body>
        <Modal.Footer><Button variant="light" onClick={close} disabled={saving}>Cancelar</Button><Button type="submit" variant="success" disabled={saving || !form.confirm_ownership}>{saving ? <><Spinner size="sm" /> Salvando...</> : "Confirmar alteração"}</Button></Modal.Footer>
      </Form>
    </Modal>
  </>;
}
